import { create } from "zustand";
import { subscribeWithSelector } from "zustand/middleware";
import type { DateFilterOption } from "../lib/date-utils";

interface EventFiltersState {
  search: string;
  selectedTags: string[];
  dateFilter: DateFilterOption;
  setSearch: (search: string) => void;
  setSelectedTags: (tags: string[]) => void;
  setDateFilter: (date: DateFilterOption) => void;
  clearFilters: () => void;
}

export const useEventFiltersStore = create<EventFiltersState>()(
  subscribeWithSelector((set) => ({
    search: "",
    selectedTags: [],
    dateFilter: "all",
    setSearch: (search) => set({ search }),
    setSelectedTags: (selectedTags) => set({ selectedTags }),
    setDateFilter: (dateFilter) => set({ dateFilter }),
    clearFilters: () =>
      set({
        search: "",
        selectedTags: [],
        dateFilter: "all",
      }),
  })),
);
